var map = {
	"./clinical-forms/en.json": 25044,
	"./clinical-forms/pt.json": 36335,
	"./en.json": 73026,
	"./onboarding/en.json": 97218,
	"./onboarding/pt.json": 87289,
	"./pt.json": 77817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88265;